var map = {
	"./account.svg": 23602,
	"./admin.svg": 76190,
	"./amount-selected.svg": 27141,
	"./amount.svg": 78469,
	"./amount0.svg": 88863,
	"./amount1.svg": 67758,
	"./amount2.svg": 96877,
	"./amount3.svg": 17164,
	"./amount4.svg": 1203,
	"./amount5.svg": 38562,
	"./amount6.svg": 93105,
	"./article-create.svg": 14906,
	"./article-ranking.svg": 99804,
	"./article.svg": 36033,
	"./auth.svg": 69287,
	"./board.svg": 87843,
	"./building.svg": 89397,
	"./car-info.svg": 13454,
	"./car-insurance.svg": 37658,
	"./cfo.svg": 82501,
	"./change-theme.svg": 4357,
	"./chart.svg": 13751,
	"./close.svg": 98179,
	"./common_file.svg": 24387,
	"./config.svg": 40907,
	"./cx.svg": 95352,
	"./dashboard.svg": 4679,
	"./database.svg": 29282,
	"./example.svg": 21649,
	"./exit-fullscreen.svg": 54861,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./fcx.svg": 58484,
	"./fullscreen.svg": 6638,
	"./goods.svg": 10049,
	"./guide.svg": 47987,
	"./hamburger-closed.svg": 85367,
	"./hamburger-opened.svg": 96408,
	"./home.svg": 49504,
	"./hsgt.svg": 78351,
	"./hsgt_lgt.svg": 80783,
	"./insurance.svg": 18095,
	"./insurance_info.svg": 31258,
	"./international.svg": 5091,
	"./introduce.svg": 43992,
	"./invoice.svg": 63414,
	"./language.svg": 5247,
	"./ling.svg": 57169,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./lock.svg": 52636,
	"./log.svg": 74193,
	"./logo.svg": 45876,
	"./logo1.svg": 9069,
	"./manage.svg": 86020,
	"./manager.svg": 45150,
	"./map.svg": 83169,
	"./mark.svg": 95746,
	"./medicine.svg": 57553,
	"./mini_app.svg": 57600,
	"./minus.svg": 93331,
	"./money.svg": 49659,
	"./nested.svg": 85016,
	"./online.svg": 96196,
	"./original.svg": 98728,
	"./other.svg": 70653,
	"./password.svg": 39902,
	"./permission.svg": 36212,
	"./personnel-info.svg": 43504,
	"./personnel-manage.svg": 53105,
	"./personnel.svg": 66595,
	"./phone-signature.svg": 4538,
	"./plus.svg": 39637,
	"./pre.svg": 43740,
	"./project.svg": 11280,
	"./purchase.svg": 21508,
	"./register-check.svg": 89777,
	"./reward.svg": 89380,
	"./role-group.svg": 84891,
	"./role.svg": 73637,
	"./salary.svg": 2043,
	"./search.svg": 58217,
	"./shareholders.svg": 24627,
	"./signature.svg": 18437,
	"./some.svg": 23485,
	"./supplier.svg": 79085,
	"./supply.svg": 26264,
	"./table.svg": 54383,
	"./team.svg": 71670,
	"./tools.svg": 87622,
	"./total.svg": 56081,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./verson.svg": 97904,
	"./video.svg": 29418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;